import { AuthGuard } from '../../../../../common/services/Auth.guard';
import { ContactComponent } from './contact.component';
import { PropertiesComponent } from './properties/properties.component';
import { GroupComponent } from './group/group.component';

export const ContactSettingsRoute = [
  {
    path: 'customer',
    component: ContactComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'property', pathMatch: 'full' },
      {
        path: 'property',
        component: PropertiesComponent,
        canActivate: [AuthGuard],
      },
      { path: 'group', component: GroupComponent, canActivate: [AuthGuard] },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/contact.route.ts